// extracted by mini-css-extract-plugin
export default {"container":"Highlights_container__Hx1sd","row":"Highlights_row__DReyq","blue":"Highlights_blue__Yh-0j","wrapper":"Highlights_wrapper__zGBQo"};